import React from "react";

const AlterationsCoatModal = () => {
    return (
        <div className="modal fade" tabIndex="-1" id="alterationsCoatModal">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">

                    <div className="modal-body p-0">
                        <div className="alterModalContent">

                            <div className="leftImage">
                                <img src="assets/images/modal.png" alt="" />
                            </div>

                            <div className="contentModalRight">

                                <div className="modal-header plModal">
                                    <h5 className="modal-title f12Size">Messages</h5>
                                    <a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
                                        <em className="icon ni ni-cross-c"></em>
                                    </a>

                                </div>

                                <h3>Cost for sleeve alterations are $6.00 per coat</h3>
                                <p>Please allow 1/2" tolerance.</p>

                                <a href="#" className="okayBtn" data-bs-dismiss="modal" aria-label="Close">
                                    Okay
                                </a>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AlterationsCoatModal;
